var React = require('react');

function GoogleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M37 25.2806C37 32.1274 32.2344 37 25.1967 37C18.4492 37 13 31.6387 13 25C13 18.3613 18.4492 13 25.1967 13C28.482 13 31.2459 14.1855 33.3754 16.1403L30.0557 19.2806C25.7131 15.1581 17.6377 18.2548 17.6377 25C17.6377 29.1855 21.0361 32.5774 25.1967 32.5774C30.0262 32.5774 31.8361 29.171 32.1213 27.4048H25.1967V23.2774H36.8082C36.9213 23.8919 37 24.4823 37 25.2806Z","fill":"currentColor"}));
}

GoogleInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = GoogleInline;

GoogleInline.default = GoogleInline;
